import { PricebookBundle, ProductTypeEnum } from '../../../models/PricebookData';
import {
  LearnMoreAdviceAndThreeNickelsUDrawer,
  LearnMoreAdviceDrawer,
  LearnMoreGuidedChoiceDrawer,
  LearnMoreThreeNickelsFreeDrawer,
} from '../../learn-more';

interface LearnMoreDrawerProps {
  pricebookBundle: PricebookBundle;
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  freemium: boolean;
}
const LearnMoreDrawer: React.FC<LearnMoreDrawerProps> = ({
  pricebookBundle,
  drawerOpen,
  setDrawerOpen,
  freemium,
}) => {
  return pricebookBundle.pricebook.productType === ProductTypeEnum.Nickels ? (
    pricebookBundle.pricebook.pricebookName === '3Nickels Advice' ? (
      <LearnMoreAdviceDrawer
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        pricebookBundle={pricebookBundle}
      />
    ) : freemium && !pricebookBundle.pricebook.pricebookName.includes('3Nickels Free') ? (
      <LearnMoreAdviceAndThreeNickelsUDrawer
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        pricebookBundle={pricebookBundle}
        freemium={freemium}
      />
    ) : (
      <LearnMoreThreeNickelsFreeDrawer
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        pricebookBundle={pricebookBundle}
      />
    )
  ) : pricebookBundle.pricebook.productType === ProductTypeEnum.NickelsU ? (
    <LearnMoreAdviceAndThreeNickelsUDrawer
      drawerOpen={drawerOpen}
      setDrawerOpen={setDrawerOpen}
      pricebookBundle={pricebookBundle}
      freemium={freemium}
    />
  ) : pricebookBundle.pricebook.productType === ProductTypeEnum.GuidedChoice ? (
    <LearnMoreGuidedChoiceDrawer
      drawerOpen={drawerOpen}
      setDrawerOpen={setDrawerOpen}
      pricebookBundle={pricebookBundle}
    />
  ) : null;
};

export default LearnMoreDrawer;
